
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Vue from 'vue';
import { Lazyload } from 'vant';

Vue.use(Lazyload);

export default {
name: "",
props: [""],
data() {
return {
list: [],
finished: false,
loading: false,
apiUrl: "",
banners: [],
warningList: [],
myUrl: ""
};
},

components: {
Loading,
},

computed: {},

beforeMount() {},
activated() {},
mounted() {

this.$http.get("./static/api/api.json").then(response => {
this.apiUrl = response.api;
this.myUrl = location.href.split("#")[0];
this.getBanner();
this.getWarningList();
this.getWxJsapiSignature();
});
},

methods: {
goMap(lat,lng,name){
const routerData = {
lat: lat,
lng: lng,
name: name
}
this.$router.push({
name: "map",
params: {
data: JSON.stringify(routerData)
}
});
},
getWarningList(){
this.loading = true;
this.$http
.get(this.apiUrl + "/web/warning/list")
.then(res => {
if (res.code === 0) {
this.loading = false;
this.warningList = res.data
this.finished = true
}
})
},
getBanner(){
this.$http
.get(this.apiUrl + "/web/banner/list")
.then(res => {
if (res.code === 0) {
this.banners = res.data
}
})
},















goList() {
this.$router.push({
path: "/deviceList",
});
},
getWxJsapiSignature() {
this.$http
.post(this.apiUrl + "/web/member/getWxJsapiSignature",{url: this.myUrl})
.then(res => {
if (res.code === 0) {
this.wxconfigdata = res.data;
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: this.wxconfigdata.appId, // 必填，公众号的唯一标识
timestamp: this.wxconfigdata.timestamp, // 必填，生成签名的时间戳
nonceStr: this.wxconfigdata.nonceStr, // 必填，生成签名的随机串
signature: this.wxconfigdata.signature, // 必填，签名
jsApiList: ["scanQRCode", "getLocation"] 
});
} else {
this.$vux.toast.text("拉取摄像头失败", "top");
}
});
},
goPersonal() {
this.$router.push({
path: "/personal",
});
},

getsys() {
let _this = this;
wx.ready(function () {
wx.scanQRCode({
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
success: function (res) {
let result = res.resultStr; 
if (result && result.indexOf(',') !== -1 ) {
let results = result.split(',');
if (results.length && results.length >= 1) {
result = results[1]
}
}
const routerData = {
imei: result
};
_this.$router.push({
name: "binding",
params: {
data: JSON.stringify(routerData)
}
});
},
});
});
},
},

watch: {},
};



// WEBPACK FOOTER //
// ./src/components/home.vue